// extracted by mini-css-extract-plugin
export default {"spinner":"spinner_spinner__ZBOZK","spin":"spinner_spin__QB3uB","grey":"spinner_grey__1FygC","white":"spinner_white__p4Y-n","black":"spinner_black__wi9Qa"};